import { FormProvider, PaginationProvider, Button } from 'dash-ui';
import { GetPropertyByIdQuery } from 'gql/generated.graphql';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import PropertyGeneralInfoForm from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/PropertyGeneralInfoForm';
import { FormFieldsList } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import { TopBarWrapper } from 'containers/properties/AdvancedPropertyDetails/AdvancedPropertyDetails.styles';

import PropertySlideshow from './components/PropertySlideshow/PropertySlideshow';

function PropertyGeneralInformation({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) {
  const { t } = useTranslation(["common"]);
  const formRef = useRef<{ submit: () => void } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEqual, setIsEqual] = useState(true);

  return (
    <FormProvider fieldsList={FormFieldsList}>
      <div style={{ padding: "8px 24px" }}>
        <TopBarWrapper
          pos="sticky"
          top={262}
          alignItems="center"
          justifyContent="flex-end"
          pr={6}
          pl={2}
          py={2}
          style={{
            float: "right",
            zIndex: 5,
            marginRight: "-24px",
            marginTop: "8px",
          }}
        >
          <Button
            px={5.5}
            medium
            onClick={() => formRef.current?.submit()}
            disabled={isLoading || isEqual}
            isLoading={isLoading}
          >
            {t("common:labels.saveChanges")}
          </Button>
        </TopBarWrapper>
        <PropertyGeneralInfoForm 
          property={property} 
          formRef={formRef}
          onLoadingChange={setIsLoading}
          onIsEqualChange={setIsEqual}
        />
        <PaginationProvider perPage={12}>
          <PropertySlideshow property={property} />
        </PaginationProvider>
      </div>
    </FormProvider>
  );
}

export default PropertyGeneralInformation;
